export default __webpack_public_path__ + "static/media/bills.844fdc08.svg";